<script lang="ts" setup>
import BaseDialog from '@/components/dialogs/BaseDialog.vue'
import EmailAutocomplete from '@/components/EmailAutocomplete.vue'

defineProps<{
  loading: boolean
}>()

const emit = defineEmits<{
  (event: 'close'): void
  (event: 'action', data: Dialogs['document/DialogAddObserver']['contextData']): void
}>()

const { t } = useI18n()

const emails = ref<string[]>([])

const isValidInput = computed(() => Boolean(emails.value.length))

const add = () => {
  emit('action', { emails: emails.value })
}
</script>

<template>
  <base-dialog
    data-cy="add_observer_dialog"
    :title="t('add_observer.dialog.title')"
    :disabled="!isValidInput || loading"
    :loading="loading"
    :action-text="t('add_observer.dialog.action')"
    :cancel-text="t('global.close')"
    @action="add"
    @close="emit('close')"
  >
    <div class="mb-4">
      {{ t('add_observer.dialog.text') }}
    </div>
    <email-autocomplete v-model="emails" multiple placeholder="name@company.com, name@company.com" />
  </base-dialog>
</template>
